<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">Recoder</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="AddMeasurerItemsForm">
              <div class="row">
                <div class="col-md-6 ">
                  <div class="form-group">
                    <label>Branch</label>
                    <ng-select class="form-control" 
                      [items]="AllBranchs" 
                      bindLabel="name" 
                      bindValue="id" 
                      formControlName="Branch">
                    </ng-select>
                    <mat-error class="mt-2"
                      *ngIf="fc.Branch.invalid && (fc.Branch.dirty || fc.Branch.touched)">
                      Branch is required
                    </mat-error>
                  </div>
                </div>
                <div class="col-md-6 ">
                  <div class="form-group">
                    <label>Item Type</label>
                    <ng-select class="form-control" 
                      [items]="ItemTypes" 
                      bindLabel="name" 
                      bindValue="id" 
                      formControlName="ItemType">
                    </ng-select>
                    <mat-error class="mt-2"
                      *ngIf="fc.ItemType.invalid && (fc.ItemType.dirty || fc.ItemType.touched)">
                      Item Type is required
                    </mat-error>
                  </div>
                </div>
                

                    <div class="col-md-6">
              <div class="form-group">
                        <label>Item</label>
                    <ng-select class="form-control"  
                      formControlName="Item">
                      <ng-option *ngFor="let item of MeasurerItemstofilter" [value]="item.id">
                        {{item.ItemName  + ' / ' + item.Code }}
                      </ng-option>
                    </ng-select>
                    <mat-error class="mt-2"
                      *ngIf="fc.Item.invalid && (fc.Item.dirty || fc.Item.touched)">
                      Item is required
                    </mat-error>
                  </div>
                </div>
               
            
                <div class="col-md-12" >
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Temp Value" type="number"  
                      formControlName="TempValue" >
                    <mat-error class="mt-2"
                      *ngIf="fc.TempValue.invalid && (fc.TempValue.dirty || fc.TempValue.touched)">
                      Temprature Value is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-12" *ngIf="hum">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Humitity Value" type="number"  
                      formControlName="HumValue" >
                    <mat-error class="mt-2"
                      *ngIf="fc.HumValue.invalid && (fc.HumValue.dirty || fc.HumValue.touched)">
                      Humitiy Value is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-12">
                  <mat-error class="mt-2 HintMessageFont">
                  {{HintMessage}}
                </mat-error>
                </div>
              </div>
              <button mat-raised-button type="submit"  class="btn primary pull-right" [disabled]="AddMeasurerItemsForm.invalid" (click)="addMeasurerItems()">Add</button>
              <div class="clearfix"></div>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
